import { PrimaryAction } from './primary_action_button.service';
import { DirectiveBase } from '../../components/angular-directive-base.directive';

export class PrimaryActionButtonController {
  public static $inject = ['PrimaryAction', '$transitions'];

  constructor(
    private primaryAction: PrimaryAction,
    private $transitions) {
    this.$transitions.onStart({}, (transition) => {
      this.primaryAction.clearActions();
    });
  }

  /**
   * A method that determines if the fab button should be shown
   * @returns true if the fab should be shown
   */
  public isFabVisible() {
    return !this.primaryAction.multiple && this.primaryAction.visible;
  }

  /**
   * A method that determines if the multiple fab button should be shown
   * @returns true if the multiple fab should be shown
   */
  public isMultipleFabVisible() {
    return this.primaryAction.multiple && this.primaryAction.visible;
  }
}